/* eslint-disable @typescript-eslint/no-unused-vars */
import { isRejectedWithValue, Middleware } from "@reduxjs/toolkit";
import { removeSecureLocalStorage, removeToken } from "../services/localStorageService";

interface RejectedAction {
  payload?: {
    status?: number;
  };
}

const sessionMiddleware: Middleware =
  (store) => (next) => (action: unknown) => {
    // console.log(store);
    if (isRejectedWithValue(action)) {
      const { status } = (action as RejectedAction).payload || {};
      // const navigate = useNavigate();

      if (status === 401) {
        console.error("Unauthorized, logging out...");
        removeToken();
        removeSecureLocalStorage('authUser')
        window.location.reload();
      }
    }
    //   console.log("Run sessionMiddleware");

    return next(action);
  };

export default sessionMiddleware;
